import * as React from "react"
import { createBookingLink, createBookingLinkParams } from "./booking-util"
import { postBookingLinkClick } from "../analytics"
import { IBookingHotel } from "../../shared-interfaces/booking-hotel"

type Props = {
  acco: IBookingHotel;
  tourSlug: string;
  withIcon: boolean;
}

const BookingLink = ({ acco, tourSlug, withIcon }: Props) => {

  const bookingLink = createBookingLink(acco.hotel_url, tourSlug)
  const bookingLinkParams = createBookingLinkParams(acco, tourSlug)

  const analytics = () => postBookingLinkClick(tourSlug, bookingLinkParams)

  return (
    <a
      className="link__external"
      href={bookingLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={analytics}
    >
      {withIcon && (<i className="icon event_available"/>)}
      Verfügbarkeit auf booking.com prüfen
    </a>
  )
}

export default React.memo(BookingLink)
